export enum DispatchEvents {
  DISPLAY_CALENDLY = 'OPEN_CALENDLY',
  DISPLAY_TOAST = 'DISPLAY_TOAST',
  SHOW_MOBILE_MENU = 'SHOW_MOBILE_MENU',
  IS_QUOTATION_POP_UP_OPEN = 'IS_QUOTATION_POP_UP_OPEN',
  SET_CATEGORY_FILTERS = 'SET_CATEGORY_FILTERS',
  SHOW_SEARCH_FORM = 'SHOW_SEARCH_FORM',
  DISPLAY_STICKY_WIDGET_MODAL = 'DISPLAY_STICKY_WIDGET_MODAL'
}
